import { useQuery } from "@tanstack/react-query";

const urlCosto = process.env.REACT_APP_URL_DIR + "Costo";

export function GetCostos() {
   const token = localStorage.getItem("token");
   const { data } = useQuery({
      queryKey: ["costo"],
      queryFn: () =>
         fetch(urlCosto, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         }).then((res) => res.json())
   });

   return data;
}

export default GetCostos;
